export default "__VITE_ASSET__C91UyLy8__"